// extracted by mini-css-extract-plugin
module.exports = {"LoadingModal":"LoadingModal_LoadingModal__1efma"};